import {Box, Typography} from "@mui/material";

export interface Props {
    message: string;
}

export const ErrorMessageView: React.FC<Props> = ({message}) => (
    <Box
        sx={{
            display: "flex",
            flexDirection: "column",
            pt: "1.5rem",
            px: "1.5rem",
            pb: "0.5rem",
        }}
    >
        <Typography sx={{fontSize: "1.375rem", lineHeight: "1.75rem", fontWeight: "500", color: "#4d5175"}}>
            {message}
        </Typography>
    </Box>
);
